module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKBAMAAAB/HNKOAAAAD1BMVEVvuPKn1Pf7/f+s1vdks/GiU1aWAAAABHRSTlPukQaJu9weVAAAACNJREFUCNdjUGRxcRBiEHFxcXFmYAGSDgwuIIBJQmQhKiG6AE2LCy3K90JrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tr_list-sytle.png
// module id = 5Ljh
// module chunks = 1